// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').SystemError} SystemError
 */

/**
 * @typedef {function(PlottrState): SystemError}
 */
export const systemErrorSelector = createSelector(fullSystemStateSelector, ({ error }) => {
  return (
    error || {
      error: null,
      storeKey: null,
      action: null,
    }
  )
})

/**
 * @type {function(PlottrState): (String | Null)}
 */
export const errorMessageSelector = createSelector(
  fullSystemStateSelector,
  (state) => state.error.error
)

/**
 * @type {function(PlottrState): (String | Null)}
 */
export const partOfStoreWhereErrorOccured = createSelector(
  fullSystemStateSelector,
  (state) => state.error.storeKey
)
